import { render, staticRenderFns } from "./ktAdmin.vue?vue&type=template&id=00b16ab5"
import script from "./ktAdmin.vue?vue&type=script&lang=js"
export * from "./ktAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports